import { MapBounds } from "movisat-maps";

export class CuadriculaModel {
    id: number;
    nombre: string;
    ancho: number;
    alto: number;
    marco: MapBounds;
    empresa: number;
}